export const convertToSnakeCase = (value) => {
  return value
    .replace(/([A-Z])/g, "_$1")
    .trim()
    ?.toLowerCase();
};

export const convertToCamelCase = (str) => {
  if (!str?.includes("_")) {
    return str;
  }
  let arr = str.split("_");

  return arr
    .map((value, index) => {
      return index === 0 ? value : value.charAt(0).toUpperCase() + value.slice(1);
    })
    ?.join("");
};

// Shallow-converts an object's top-level keys from camelCase to snake_case.
// Adapts camelCase GraphQL rows to the snake_case keys the grids read.
// Intentionally uses this module's `convertToSnakeCase` (NOT lodash `snakeCase`):
// the grid columns build their `field` via `convertToSnakeCase(key)`, and lodash
// normalizes acronyms/numbers differently (e.g. "instrumentGTIN" ->
// lodash "instrument_gtin" vs "instrument_g_t_i_n" here), which would make the
// data keys not match the column fields. Keeping one converter guarantees they align.
export const convertKeysToSnakeCase = (obj) => {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
    return obj;
  }
  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[convertToSnakeCase(key)] = value;
    return acc;
  }, {});
};

export const replaceSpecialCharsWithSpace = (value) => {
  if (!value || typeof value !== 'string') {
    return value;
  }
  return value.replace(/[!@#$%^&*()+=|[\]{};:|,<>?~ \-"/]/g, "");
};
